export default "__VITE_ASSET__cbff561d__"